import {
    Close
} from '@mui/icons-material';
import {
    Box, Container,
    IconButton,
    Modal,
    Stack, Typography
} from '@mui/material';
import CoinIcon from '../icons/Coin';
import PointIcon from '../icons/Point';

export default function ChallengePointsInfo({ open, handleClose }) {
    return (
        <Modal
        open={open}
        onClose={handleClose}
        >
        <Container maxWidth={'xs'} className='modal-container' sx={{ padding: 3 }}>
        <Box sx={{ flex: 'auto' }} className='spread-y'>
            <Stack spacing={2}>
                <Box className='spread-x' sx={{ alignItems: 'start' }}>
                    <Typography variant="h6">
                        Ready to make a positive impact on the planet and get rewarded along the way? 
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <Close />
                    </IconButton>
                </Box>
                <Typography variant="body2">
                Here's how it works: take on our fun, eco-friendly actions designed to help you build sustainable habits and lower your carbon footprint. 
                </Typography>

                <Box className='centered-container'>
                    <PointIcon size={40} />
                </Box>

                <Typography variant="body2">
                For each completed action or challenge, you'll earn <i><b style={{ color: 'var(--dark-green)' }}>points</b></i> that will boost your rank on the leaderboard, letting you compete with others who are also making a difference!
                </Typography>
                
                <Box className='centered-container'>
                    <CoinIcon size={40} />
                </Box>
                
                <Typography variant="body2">
                Points earned also translate into <i><b style={{ color: 'var(--dark-yellow)' }}>coins</b></i> that you can then use to claim cool gifts from our Rewards Store — tote bags, water bottles, and more! Every action you take counts toward a greener future, and you'll be one step closer to becoming a Green Hero. 🌍💚
                </Typography>
            </Stack>
        </Box>
        </Container>
        </Modal>
    )   
}